/* Shared analytics constants and pure helpers. */

export const COLORS = [
  "#1d4ed8", "#059669", "#d97706", "#dc2626", "#7c3aed",
  "#0891b2", "#db2777", "#65a30d", "#475569", "#ea580c",
];

export const PERIOD_PILLS = [
  { key: "7d", label: "7 dias" },
  { key: "30d", label: "30 dias" },
  { key: "90d", label: "90 dias" },
  { key: "month", label: "Este mês" },
  { key: "lastMonth", label: "Mês passado" },
  { key: "year", label: "Este ano" },
  { key: "all", label: "Tudo" },
];

export const SLIDES = [
  { key: "geral", label: "Visão geral" },
  { key: "pessoas", label: "Por pessoa" },
  { key: "procedimentos", label: "Procedimentos" },
  { key: "financeiro", label: "Financeiro" },
  { key: "heatmap", label: "Heatmap" },
  { key: "suspensoes", label: "Suspensões" },
];

export const WEEKDAY_ORDER = [
  "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo",
];

export function brl(n) {
  return (Number(n) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function num(n) {
  return (Number(n) || 0).toLocaleString("pt-BR");
}

export function monthLabel(m) {
  if (!m || m === "—") return "—";
  const [y, mm] = m.split("-");
  const names = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  return `${names[parseInt(mm, 10) - 1] || mm}/${y.slice(-2)}`;
}

/** Translate a quick-select pill key into {from, to} ISO date range. */
export function pillRange(key) {
  const today = new Date();
  const iso = (d) => d.toISOString().slice(0, 10);
  if (key === "all") return { from: "", to: "" };
  if (key === "7d") {
    const f = new Date(today); f.setDate(f.getDate() - 7);
    return { from: iso(f), to: iso(today) };
  }
  if (key === "30d") {
    const f = new Date(today); f.setDate(f.getDate() - 30);
    return { from: iso(f), to: iso(today) };
  }
  if (key === "90d") {
    const f = new Date(today); f.setDate(f.getDate() - 90);
    return { from: iso(f), to: iso(today) };
  }
  if (key === "month") {
    const f = new Date(today.getFullYear(), today.getMonth(), 1);
    return { from: iso(f), to: iso(today) };
  }
  if (key === "lastMonth") {
    const f = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const t = new Date(today.getFullYear(), today.getMonth(), 0);
    return { from: iso(f), to: iso(t) };
  }
  if (key === "year") {
    const f = new Date(today.getFullYear(), 0, 1);
    return { from: iso(f), to: iso(today) };
  }
  return { from: "", to: "" };
}

export const EMPTY_FILTERS = {
  date_from: "", date_to: "",
  surgeon_id: "", assistant_id: "", anesthesiologist_id: "",
  instrument_technician_id: "", hospital_id: "", procedure_id: "",
  period: "", status: "",
  only_confirmed: false, include_suspended: true,
};
